import React from 'react';
import Carousel from "js/components-v2/pages/BuyerPage/Carousel";
import userCountry from 'js/services/UserCountry';
import CarouselNG from 'js/components-v2/pages/BuyerPage/CarouselNG';
import {Button, Section} from "js/new/Components";

export function FastestWayToSellOnline({
  head = 'The fastest and most trusted way to sell online in Nigeria',
  body = 'Join over 1200+ active Nigerian sellers who use PayOnDelivery.com to sell online. With PayOnDelivery.com, your payment is guaranteed. The buyer’s payment is held to cover the purchase and either accepts or returns the item safely to you.',
}) {
  return (
    <div className="tw-relative">
      <Section className="tw-flex tw-flex-col tw-items-center tw-space-y-4 tw-z-10">
        <h1 className="tw-text-center tw-z-10 tw-text-black !tw-mb-0">{head}</h1>
        <p className="tw-max-w-3xl tw-text-center tw-z-10">{body}</p>
        <div className="tw-w-full md:tw-w-auto tw-z-10">
          <Button illustrated className="tw-w-full md:tw-w-auto tw-z-10" href={'/create-link'}>
            Start selling faster
          </Button>
        </div>
      </Section>

      <img
        loading='lazy'
        src="/assets/brand/pod-bg-logo-right.png"
        alt="PayOnDelivery"
        className="tw-absolute tw-bottom-0 tw-left-0 tw-h-[359.27px] tw-w-[269.06px] tw-max-w-full tw-z-0"
      />
    </div>
  );
}
